module.exports = "pegasus/assets/header-6-basic.png";